import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-network-asset',
  templateUrl: './network-asset.component.html',
  styleUrl: './network-asset.component.scss',
  standalone: false,
})
export class NetworkAssetComponent {
  @Output() sendItems = new EventEmitter<
    { label: string; iconKey: string }[]
  >();
  constructor() {}

}
